import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const checkTokenValidity = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setIsAuthenticated(false);
            setIsLoading(false);
            navigate('/login');
            return;
        }

        try {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Math.floor(Date.now() / 1000);

            const isExpired = decodedToken.exp < currentTime;

            if (isExpired) {
                console.log("Token expired");
                localStorage.removeItem('token');
                setIsAuthenticated(false);
                setIsLoading(false);
                navigate('/login');
                return;
            }

            setIsAuthenticated(true);
            setIsLoading(false);
        } catch (error) {
            console.error("Error checking token validity:", error);
            localStorage.removeItem('token');
            setIsAuthenticated(false);
            setIsLoading(false);
            navigate('/login');
        }
    };

    useEffect(() => {
        checkTokenValidity();

        // Set up the interval for periodic checks, right now it's 10 seconds
        const intervalId = setInterval(checkTokenValidity, 1000);

        return () => clearInterval(intervalId);
    }, []);

    return { isAuthenticated, isLoading };
};

export default useAuth;